module.exports = __webpack_public_path__ + "static/media/Niveau_elN9_2_734584.76eb82ec.png";